import { connect } from 'react-redux';

import { StoreState } from '../types';
import { getAuthError, getBranding } from '../reducers';
import Login, { LoginProps } from '../components/Login';
import { getEmailVerificationData } from '../reducers/emailVerification';
import { getLanguageReady } from 'src/reducers/i18n';

export default connect(mapStateToProps)(Login);

function mapStateToProps(state: StoreState): LoginProps {
  return {
    authError: getAuthError(state),
    branding: getBranding(state),
    emailVerificationData: getEmailVerificationData(state),
    languageReady: getLanguageReady(state)
  };
}



// WEBPACK FOOTER //
// ./src/containers/Login.tsx